module.exports = __webpack_public_path__ + "static/1191395081-wide.492d0985.jpg";